import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import { toggleFilter, hideFilter } from '../../../../../../redux/actions/FilterActions';
import { dealersFetch } from 'redux/actions/DealerActions';
import { Box, IconButton, makeStyles, Tooltip, Drawer } from '@material-ui/core';
import { FilterList } from '@material-ui/icons';
import { alpha } from '@material-ui/core/styles';
import clsx from 'clsx';
import FilterForm from '../../../../../../components/form/filter/FilterForm';
import { DEALER_TYPES, MANAGER_TYPES } from 'constants/Systems';

const useStyles = makeStyles(theme => ({
  iconRoot: {
    position: 'relative',
    color: alpha(theme.palette.common.white, 0.9),
    '&:hover, &.active': {
      color: theme.palette.common.white,
    },
  },
  paper: {
    width: 375,
  },
}));

const HeaderFilter = () => {
  const classes = useStyles();
  const intl = useIntl();
  const dispatch = useDispatch();
  const filter = useSelector(({ filter }) => filter);
  const authUser = useSelector(({ auth: { authUser } }) => authUser);

  useEffect(() => {
    if (authUser && authUser._id) {
      if (DEALER_TYPES.includes(authUser.type) || MANAGER_TYPES.includes(authUser.type)) {
        let dealer_codes = authUser.dealers.map(o => o.dealer_code);
        dispatch(
          dealersFetch({
            dealer_code: dealer_codes,
            sort: 'ho_code',
            order: 'asc',
          }),
        );
      } else {
        dispatch(dealersFetch({ sort: 'ho_code', order: 'asc' }));
      }
    }
  }, [authUser]);

  return (
    <Box pr={2}>
      <Tooltip title={`${intl.formatMessage({ id: 'filter' })}`}>
        <IconButton
          onClick={() => {
            dispatch(toggleFilter());
          }}
          className={clsx(classes.iconRoot, 'Cmt-appIcon', {
            active: filter.show,
          })}>
          <FilterList />
        </IconButton>
      </Tooltip>
      <Drawer
        anchor={filter.anchor}
        open={filter.show}
        onClose={() => {
          dispatch(hideFilter());
        }}
        classes={{ paper: classes.paper }}
        ModalProps={{ keepMounted: true }}>
        <Box m={5}>
          <FilterForm />
        </Box>
      </Drawer>
    </Box>
  );
};

export default HeaderFilter;
